module.exports = ".educations {\n    padding-top: 13px;\n    padding-bottom: 13px;\n}"